var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "custom-information-panel" }, [
    _c("div", { staticClass: "custom-information" }, [
      _c("p", [_vm._v(_vm._s(_vm.title))])
    ]),
    _c("div", { staticClass: "custom-information-detail" }, [
      _c("div", [
        _c("p", [_vm._v("Nuevo:")]),
        _c("p", [_c("b", [_vm._v(_vm._s(_vm.news))])])
      ]),
      _c("div", [
        _c("p", [_vm._v("Renovación:")]),
        _c("p", [_c("b", [_vm._v(_vm._s(_vm.renovation))])])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }